/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center"> {{ $t('UpdateProfile.title') }} </h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">

        <div v-if="user">
          <!-- Bloc photo -->
          <div class="mc-user-update-profile ion-margin-bottom" >
            <div class="mc-user-image">
              <ion-thumbnail>
                  <img v-if="checkAvatarDefault" :src="webURL + user.avatars[0]" alt="" />
                  <img v-else :src="user.avatars[0]" alt="" />
              </ion-thumbnail>
            </div>

            <ion-button class='mc-small-button' color="primary" fill="outline" @click="$refs.imageInput.click()">
              <ion-icon class="ion-margin-end" name="create"></ion-icon> {{ $t('UpdateProfile.photo') }}
            </ion-button>
            <input ref="imageInput" style="display: none" type="file" @change="changePicture($event)" />
          </div>

          <!-- Form -->

          <ion-item>
            <ion-label position="stacked">{{$t('Register.givenName')}} *</ion-label>
            <ion-input
              type="text"
              :placeholder="$t('Register.givenName') + '*'"
              :value="user.givenName"
              @input="user.givenName = $event.target.value"
            >
            </ion-input>
          </ion-item>
          <div v-if="v$.user.givenName.$error">
            <div class="mc-error-label"  v-if="v$.user.givenName.required.$invalid">{{$t('Validation.required')}}</div>
          </div>

          <ion-item>
            <ion-label position="stacked">{{$t('Register.familyName')}} *</ion-label>
            <ion-input
              type="text"
              :placeholder="$t('Register.familyName') + '*'"
              :value="user.familyName"
              @input="user.familyName = $event.target.value"
            >
            </ion-input>
          </ion-item>
          <div v-if="v$.user.familyName.$error">
            <div class="mc-error-label"  v-if="v$.user.familyName.required.$invalid">{{$t('Validation.required')}}</div>
          </div>

          <ion-item>
            <ion-select
              required
              label-placement="stacked"
              :value="user.gender"
              @ionChange="user.gender = Number($event.target.value)"
              :cancel-text="$t('Commons.cancel')"
              :placeholder="$t('Commons.choose')"
            >
              <div slot="label">{{$t('Register.gender')}} *</div>
              <ion-select-option v-if="genderNC" :value="3">{{$t('Register.nc')}}</ion-select-option>
              <ion-select-option :value="2">{{$t('Register.male')}}</ion-select-option>
              <ion-select-option :value="1">{{$t('Register.female')}}</ion-select-option>
            </ion-select>
          </ion-item>
          <div v-if="v$.user.gender.$error">
            <div class="mc-error-label"  v-if="v$.user.gender.required.$invalid">{{$t('Validation.required')}}</div>
          </div>

          <ion-item>
            <ion-label position="stacked">{{$t('Register.email')}} *</ion-label>
            <ion-input
              type="text"
              :placeholder="$t('Register.email') + '*'"
              :value="user.email"
              disabled
              @input="user.email = $event.target.value"
            >
            </ion-input>
          </ion-item>
          <div v-if="v$.user.email.$error">
            <div class="mc-error-label"  v-if="v$.user.email.required.$invalid">{{$t('Validation.required')}}</div>
            <div class="mc-error-label"  v-if="v$.user.email.email.$invalid">{{$t('Validation.email')}}</div>
          </div>

          <ion-grid class="ion-no-margin">
            <ion-row>
              <ion-col size="4" v-if="user.phoneCode">
                <ion-item>
                  <ion-label position="stacked">{{$t('Register.indicatif')}} *</ion-label>
                  <ion-select :value="user.phoneCode" @ionChange="user.phoneCode = Number($event.target.value)" :cancel-text="'Annuler'" style="font-size: 14px;">
                    <ion-select-option v-for="indicatif in indicatifs" v-bind:value="indicatif.value" >
                      <div><span :class="'fi fi-' + indicatif.country"></span> {{indicatif.code}}</div>
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
              <ion-col :size="!!user.phoneCode ? 8 : 12">
          <ion-item>
            <ion-label position="stacked">{{$t('Register.phone')}} *</ion-label>
            <ion-input
              type="text"
              name="telephone"
              :value="user.telephone"
              @input="user.telephone = $event.target.value"
              :placeholder="$t('Register.phone')"
            ></ion-input>
            <ion-icon slot="end" color="success" class="ion-margin-top" v-if="user.phoneValidatedDate" name="checkmark"></ion-icon>
          </ion-item>
          <div v-if="v$.user.telephone.$error">
            <div class="mc-error-label"  v-if="v$.user.telephone.required.$invalid">{{$t('Validation.required')}}</div>
          </div>
              </ion-col>
            </ion-row>
          </ion-grid>

          <div v-if="!user.phoneValidatedDate" class="mc-button-phone">
            <ion-button class='mc-small-button' fill="outline" color="primary" v-on:click='setPhoneToken'>
              <ion-icon v-if="loadingPhoneToken" size="large" class="rotating" name="sync"></ion-icon>
              <span v-if="!loadingPhoneToken">{{ $t('UpdateProfile.phoneToken') }}</span>
            </ion-button>
          </div>


          <div class="phone-visibility">
            <ion-item lines="none">
              <ion-radio-group v-model="user.phoneDisplay">
                <ion-item lines="none" >
                  <ion-radio labelPlacement="end" slot="start" :value="1" >{{$t('UpdateProfile.visibility-accepted')}}</ion-radio>
                </ion-item>

                <ion-item lines="none">
                  <ion-radio labelPlacement="end" slot="start" :value="2" >{{$t('UpdateProfile.visibility-all')}}</ion-radio>
                </ion-item>
              </ion-radio-group>
            </ion-item>
          </div>


          <ion-item v-if="askBirthdate">
            <ion-label >{{ $t('Register.birthDate') }} <span v-if="requiredBirthdate">*</span></ion-label>
            <ion-datetime-button slot="end" datetime="datePicker"></ion-datetime-button>
            <ion-modal :keep-contents-mounted="true">
            <ion-datetime
              id="datePicker"
              presentation="date"
              display-format="DD/MM/YYYY"
              picker-format="DD/MM/YYYY"
              :cancel-text="$t('Commons.cancel')"
              :done-text="$t('Commons.validate')"
              :show-default-buttons="true"
              :value="user.birthDate"
              :first-day-of-week="1"
              @ionChange="user.birthDate = $event.detail.value"
            ></ion-datetime>
            </ion-modal>
          </ion-item>
          <div v-if="v$.user.birthDate.$error">
            <div class="mc-error-label"  v-if="v$.user.birthDate.required.$invalid">{{$t('Validation.required')}}</div>
            <div class="mc-error-label"  v-if="v$.user.birthDate.isMaxBirthDate.$invalid">{{$t('Validation.age', { value: minAge })}}</div>
          </div>

          <ion-item  v-on:click="goGeoSearch('update_user_address', 'search')">
            <ion-label position="stacked">{{$t('Register.address')}} *</ion-label>
            <ion-input
              type="text"
              name="address"
              :value="formatAddress(user.addresses[0])"
              readonly="true"
              class="no-clickable ellipsis"
              v-bind:placeholder="$t('Register.address')"
            ></ion-input>
          </ion-item>
          <div v-if="v$.user.addresses.$error">
            <div class="mc-error-label"  v-if="v$.user.addresses.required.$invalid">{{$t('Validation.required')}}</div>
            <div class="mc-error-label"  v-if="v$.user.addresses.fullAddress.$invalid">{{$t('Register.fullAddress')}}</div>
          </div>

          <ion-item>
            <ion-label position="stacked">{{$t('Register.postalAddress')}}</ion-label>
            <ion-input
              type="text"
              name="address"
              :value="user.postalAddress"
              @input="user.postalAddress = $event.target.value"
              v-bind:placeholder="$t('Register.postalAddress')"
            ></ion-input>
          </ion-item>

          <div class="text-left ion-margin-top ion-margin-bottom" v-if="isHitchHiking() && user.addresses && user.addresses[0]">
            <div><small><ion-label position="stacked">{{$t('HitchHiking.register.total-address')}}</ion-label></small></div>
            <div>{{user.givenName}} {{user.familyName}}</div>
            <div>{{user.postalAddress}}</div>
            <div>
              <div>{{user.addresses[0].houseNumber}} {{user.addresses[0].streetAddress}}</div>
              <div>{{user.addresses[0].postalCode}} {{user.addresses[0].addressLocality}}</div>
            </div>
          </div>


          <ion-item>
            <ion-label position="stacked">{{ $t('Register.drivingLicenceNumber') }}</ion-label>
            <ion-input
              type="text"
              name="drivingLicenceNumber"
              :value="user.drivingLicenceNumber"
              @input="user.drivingLicenceNumber = $event.target.value"
              :placeholder="$t('Register.drivingLicenceNumber')"
            ></ion-input>
          </ion-item>
          <div v-if="v$.user.drivingLicenceNumber.$error">
          </div>


          <ion-item lines="none">
            <ion-checkbox
              name="newsSubscription"
              :value="user.newsSubscription"
              color="primary"
              slot="start"
              @ionChange="changeNewsSubscription($event)"
              :checked="user.newsSubscription"
              label-placement="end"
            >{{ $t('UpdateProfile.newsSubscription') }}</ion-checkbox>
          </ion-item>

          <br>
          <ion-button class='mc-small-button' color="success" expand="block" @click="updateUser()">
            <span v-if="this.$store.state.userStore.status == 'loading'">
            <ion-icon size="large" class="rotating" name="sync"></ion-icon>
          </span>
            <span v-if="this.$store.state.userStore.status != 'loading'">
          {{ $t('Commons.save') }}
          </span>
          </ion-button>

          <br>
          <ion-button class='mc-small-button' color="primary" fill="outline" expand="block" @click="updatePassword()">
            {{ $t('UpdateProfile.updatePassword') }}
          </ion-button>

        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
  .mc-user-update-profile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--ion-color-primary);

    .mc-user-bloc-info {
      display: flex;
    }

    ion-thumbnail {
      --size: 90px;
      --border-radius: 50%;
    }
  }

  .phone-visibility {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .mc-button-phone {
    text-align: right;
    width: 100%;
  }
</style>

<script>
  import {required, email, sameAs, minLength, helpers, requiredIf} from '@vuelidate/validators'
  import { toast } from '../../Shared/Mixin/toast.mixin';
  import { address } from '../../Shared/Mixin/address.mixin';
  import Compressor from 'compressorjs';
  import {isPlatform} from "@ionic/core";
  import {alertController} from "@ionic/vue";
  import useVuelidate from "@vuelidate/core";

  var moment = require('moment');

  const isMaxBirthDate = (value, vm) => {
    if (JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE)) {
      let n = new Date();
      n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
      return moment(value).isBefore(moment(n.toISOString()));
    } else {
      return true;
    }
  }

  export default {
    name: 'update-profile',
    setup () {
      return { v$: useVuelidate() }
    },
    data () {
      return {
        user: null,
        maxBirthDate: this.getMaxBirthDate(),
        minAge: process.env.VUE_APP_REGISTER_MIN_AGE,
        askBirthdate: JSON.parse(process.env.VUE_APP_ASK_BIRTHDATE),
        requiredBirthdate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE),
        genderNC: JSON.parse(process.env.VUE_APP_GENDER_NC),
        indicatifs: JSON.parse(process.env.VUE_APP_PHONE_IND),
        webURL: process.env.VUE_APP_WEB_URL,
        loadingPhoneToken: false,
        now: new Date().toISOString(),
        fullAddressRequired: JSON.parse(process.env.VUE_APP_REGISTER_FULL_ADDRESS),
      }
    },
    mixins: [toast, address],
    validations() { return {
      user: {
        givenName: {
          required,
        },
        familyName: {
          required
        },
        gender: {
          required,
        },
        email: {
          required,
          email
        },
        phoneCode: {
          required: requiredIf(function () {
            return this.user.phoneCode;
          }),
        },
        telephone: {
          required,
        },
        addresses: {
          required,
          fullAddress(address) {
            return this.fullAddressRequired ? (address[0] ? (address[0].type === "housenumber" || address[0].type === "street" )  : false) : true;
          }
        },
        birthDate: {
          required : requiredIf(function () {
            return this.requiredBirthdate;
          }),
          isMaxBirthDate
        },
        drivingLicenceNumber: {

        }
      }
    }},
    computed: {
      checkAvatarDefault() {
        const path = this.user.avatars;
        const avatarDefaultPath = '/images/avatarsDefault/square_100.svg'
        if (path && path.includes(avatarDefaultPath)) {
          return true;
        }
      }
    },
    created() {
      this.$store.state.userStore.userToUpdate = this.$store.state.userStore.user;
      this.user = this.$store.state.userStore.userToUpdate;
    },
    methods: {
      changePicture(e) {
        const file = e.target.files[0];
        if (file) {
          if (this.user.images && this.user.images.length > 0) {
            Promise.all([this.user.images.map(item => {
              return this.$store.dispatch('deleteImage', item.id);
            })]).then(() => {
              this.compressFile(file);
            })
          } else {
            this.compressFile(file);
          }
        }

      },
      compressFile: function (file) {
        const context = this;
        new Compressor(file, {
          convertSize: 1000000,
          success(result) {
            if (result) {
              context.updateUserPicture(new File([result], file.name, {type: result.type}));
            }
          },
          error(err) {
            context.presentToast(this.$t("Commons.error"), 'danger')
          },
        });
      },
      updateUserPicture(file) {
        this.$store.dispatch('updateUserPicture', { userId : this.user.id, file: file })
          .then(res => {
            this.$store.dispatch('getUser', { idUser: this.user.id }).then(res => {
              this.user.avatars = this.$store.state.userStore.user.avatars;
            });
            this.presentToast(this.$t("UpdateProfile.picture-success"), 'success')
          })
          .catch(err => {
            this.presentToast(this.$t("Commons.error"), 'danger')
          });
      },
      updateUser() {
        this.v$.$reset();
        this.v$.$touch();
        console.log(this.v$)
        if (!this.v$.$invalid) {
          if (this.user.oldHomeAddress) {
            delete this.user.oldHomeAddress['@id']
            delete this.user.oldHomeAddress.id
          }

          this.$store.dispatch('updateUser', this.user)
            .then(res => {
              this.$router.push('profile');
              this.$store.state.userStore.userToUpdate = null;
              this.presentToast(this.$t("UpdateProfile.success"), 'success')
            })
            .catch(err => {
              this.presentToast(this.$t("Commons.error"), 'danger')
            });
        }
      },
      setPhoneToken() {
        this.v$.$reset();
        this.v$.$touch();
        if (!this.v$.$invalid) {
          this.loadingPhoneToken = true;
          this.$store.dispatch('updateUser', this.user).then(res => {
            this.$store.dispatch('generatePhoneToken', this.user.id)
              .then(res => {
                this.loadingPhoneToken = false;
                this.displayPhoneTokenAlert(res.data.telephone);
              })
              .catch(() => {
                this.loadingPhoneToken = false;
                this.presentToast(this.$t("Commons.error"), "danger");
              });
          }).catch(() => {
            this.loadingPhoneToken = false;
          });
        }
      },
      displayPhoneTokenAlert(phone) {
        return alertController
          .create({
            header: this.$t('UpdateProfile.phoneTokenPopup'),
            message: this.$t('UpdateProfile.phoneTokenPopupDesc', {value: phone}),
            inputs: [
              {
                name: "phoneToken",
                id: "phoneToken",
                placeholder: this.$t('UpdateProfile.phoneTokenPopupCode')
              }
            ],
            buttons: [
              {
                text: 'Annuler',
                role: "cancel",
                cssClass: "secondary",
                handler: () => {

                }
              },
              {
                text: 'Vérifier',
                handler: data => {
                  if (data.phoneToken) {
                    this.checkPhoneToken(data.phoneToken);
                  } else {
                    this.presentToast(
                      `Il n'y a pas de code`,
                      "danger"
                    );
                  }
                }
              }
            ]
          })
          .then(a => a.present());
      },
      checkPhoneToken(phoneToken) {
        this.$store.dispatch('checkPhoneTokenPost', {telephone : this.user.telephone, phoneToken : phoneToken})
          .then(res => {
            if (res) {
              this.$store.dispatch('getUser', { idUser: this.user.id }).then(res => {
                this.user = Object.assign({}, this.$store.state.userStore.user );
              });
              this.presentToast(this.$t("Commons.success"), "success");
            } else {
              this.presentToast(this.$t("Commons.error"), "tertiary");
            }
          })
          .catch(() => {
            this.presentToast(this.$t("Commons.error"), "tertiary");
          });
      },
      goGeoSearch(type, action) {
        this.$router.push({ name: "geoSearch", query: { type, action, fullAddressRequired: this.fullAddressRequired }});
      },
      changeNewsSubscription(event){
        this.user.newsSubscription = event.detail.checked
      },
      getMaxBirthDate() {
        let n = new Date();
        n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
        return n.toISOString();
      },
      isHitchHiking() {
        return this.$router.currentRoute.path && this.$router.currentRoute.path.includes('hitchhiking');
      },
      updatePassword() {
        return alertController
          .create({
            header: this.$t("UpdateProfile.updatePassword"),
            inputs: [
              {
                name: "password",
                id: "password",
                placeholder: this.$t("Login.password-placeholder")
              },
              {
                name: "confirmPassword",
                id: "confirmPassword",
                placeholder: this.$t("Login.confirm-password-placeholder")
              }
            ],
            buttons: [
              {
                text: this.$t("Commons.cancel"),
                role: "cancel",
                cssClass: "secondary",
                handler: () => {}
              },
              {
                text: this.$t("Login.newPassword"),
                handler: (data) => {
                  if (data.password == data.confirmPassword) {
                    this.$store.dispatch('updatePassword', {id: this.user.id, password: data.password}).then(() => {
                      this.presentToast("Le mot de passe a bien été réinitialisé", "success");
                    }).catch(() => {
                      this.presentToast(this.$t("Commons.error"), "danger");
                    });
                  } else {
                    this.presentToast("Le mot de passe et sa confirmation doivent être identiques", 'danger')
                  }
                }
              }
            ]
          })
          .then(a => a.present());
      },
    }
  }
</script>
